/**
 *
 * 信息、栏目
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/8/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import {Button,Row,Col, Table} from 'antd';
import dayjs from 'dayjs';
import Lang from "@components/Lang/Lang";
import {toFixed2} from '@utils/utils';
const SumRow = Table.Summary.Row, SumCell = Table.Summary.Cell;
export function getInfo(orderType,orderInfo){
    let info = '';
    switch (orderType) {
        case 'freight':
            info = (<div>
                {/* 表头 */}
                <Row className="padding-top-10 padding-bottom-10 bar">
                    <Col span={7}>
                        <span>{Lang({id: "HeTongBianHao",default: "合同编号"})}：</span>
                        <span>{orderInfo.contractCode||'-'}</span>
                    </Col>
                    <Col span={7}>
                        <span>{Lang({id: "JiGuiDanHao",default: "集柜单号"})}：</span>
                        <span>{orderInfo.containerCode||'-'}</span>
                    </Col>
                    <Col span={7}>
                        <span>{Lang({id: "RiQi",default: "日期"})}：</span>
                        <span>{orderInfo.actLoadDate?dayjs(orderInfo.actLoadDate).format("YYYY-MM-DD"):"-"}</span>
                    </Col>
                </Row>
                {/*<div  className="padding-top-10 padding-bottom-10 border-bottom">*/}
                {/*{orderInfo.destinationInfo}*/}
                {/*</div>*/}
                <div className="border-bottom">
                    <Row className="padding-top-10 padding-bottom-10">
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "FaJianRenMaiJia",default: "发件人/卖家"})}：</Col>
                                <Col span={20}>
                                    <p>{orderInfo.newSellerCompanyName||'-'}</p>
                                    <p>{Lang({id: "DiZhi",default: "地址"})}：{orderInfo.newSellerCompanyAddress || '-'}</p>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "MaiFang",default: "买方"})}：</Col>
                                <Col span={20}>
                                    <p>{orderInfo.buyerCompanyName || '-'}</p>
                                    <p>{Lang({id: "DiZhi",default: "地址"})}：{orderInfo.buyerCompanyAddress || '-'}</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="padding-top-10 padding-bottom-10">
                        <Col span={12}>
                            {orderInfo.freightMode ==2?null:<Row>
                                <Col span={4}>{Lang({id: "JiGu",default: "集柜"})}：</Col>
                                <Col span={20}>
                                    <span>{orderInfo.cabinetNum||'-'}</span>
                                </Col>
                            </Row>}
                        </Col>
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "MuDiDiGuoJia",default: "目的地国家"})}：</Col>
                                <Col span={20}>
                                    <span>{orderInfo.destinationCountry||'-'}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={4}>{Lang({id: "MuDiDiCheZhan",default: "目的地车站"})}：</Col>
                                <Col span={20}>
                                    <span>{orderInfo.destinationReceiver||'-'}</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                {/* 表头 END */}
            </div>)
            break;
        case 'freightPay':
            info = (<div className={"mt_16"}>
                <div className="pt_8 pb_8">{orderInfo.newSellerCompanyName}</div>
                <div className="pt_8 pb_8">
                    {orderInfo.newSellerCompanyAddress}
                </div>
                <div className="pt_8 pb_8 bar">
                    {Lang({id: 'YunFeiFuKuanDan', default: '运费付款单'})}
                </div>
                {/* 表头 */}
                <Row>
                    <Col span={12}>
                        <span>{Lang({id: "ChuFaDi",default: "出发地"})}：</span>
                        <span>{orderInfo.domesticStartPlaceName||'-'}， China</span>
                    </Col>
                    <Col span={12}>
                        <span>{Lang({id: "RiQi",default: "日期"})}：</span>
                        <span>{orderInfo.actLoadDate?dayjs(orderInfo.actLoadDate).format('YYYY-MM-DD'):'-'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <span>{Lang({id: "MuDiDi",default: "目的地"})}：</span>
                        <span>
                            Moscow, {orderInfo.endPlaceName||'-'}
                        </span>
                    </Col>
                    <Col span={12}>
                        {orderInfo.cabinetNum || '-'}
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>{Lang({id: "YunShuFangShi",default: "运输方式"})}：{orderInfo.freightModeName}</Col>
                </Row>
                {/*<div  className="padding-top-10 padding-bottom-10 border-bottom">*/}
                {/*{orderInfo.destinationInfo}*/}
                {/*</div>*/}

                {/* 表头 END */}
            </div>)
            break;
        case 'goods':
        case 'goods_sub':
            info =  <div  className="padding-top-10 padding-bottom-10 bar">
                <div className={"text-center"}>
                    <p className={"font-20 padding-top-10 padding-bottom-10 color-black"}>{orderInfo.companyNameEn}</p>
                    <p>{orderInfo.companyNameZh}</p>
                </div>
                <div className="border-bottom padding-top-10 padding-bottom-10">
                    {orderInfo.companyAddress}
                </div>
                <p> {orderInfo.desc}</p>
            </div>;
            break;
        case'price':
            info = <div  className="padding-top-10 padding-bottom-10 bar">
                <div className={"text-center"}>
                    <p className={"font-20 padding-top-10 padding-bottom-10 color-black"}>{orderInfo.companyNameEn}</p>
                </div>
                <div className="border-bottom padding-top-10 padding-bottom-10">
                    {orderInfo.companyAddress}
                </div>
                <div className="padding-top-10 padding-bottom-10">
                    <p> {orderInfo.descOne}</p>
                    <p> {orderInfo.descTwo}</p>
                </div>
            </div>;
            break;
        case 'load':
        case'load_sub':
            info = <div>
                <Row className="padding-top-10 padding-bottom-10 bar">
                    <Col span={5}>
                        <span>{Lang({id: "JiGuiDanHao",default: "集柜单号"})}：</span>
                        <span>{orderInfo.containerCode||'-'}</span>
                    </Col>
                    <Col span={5}>
                        <span>{Lang({id: "GuiHao",default: "柜号"})}：</span>
                        <span>{orderInfo.cabinetNum||'-'}</span>
                    </Col>
                    <Col span={5}>
                        <span>{Lang({id: "ShiZhuangGuiRiQi",default: "实装柜日期"})}：</span>
                        <span>{orderInfo.actLoadDate?dayjs(orderInfo.actLoadDate).format("YYYY-MM-DD"):"-"}</span>
                    </Col>
                    <Col span={5}>
                        <span>{Lang({id: "HangXianMingCheng",default: "航线名称"})}：</span>
                        <span>{orderInfo.routeName}</span>
                    </Col>
                </Row>
            </div>;
            break;
        case 'trucking':
        case 'trucking_sub':
            info = <div>
                <Row className="padding-top-10 padding-bottom-10 bar">
                    <Col span={7}>
                        <span>{Lang({id: "HeTongBianHao",default: "合同编号"})}：</span>
                        <span>{orderInfo.contractCode||'-'}</span>
                    </Col>
                    <Col span={7}>
                        <span>{Lang({id: "JiGuiDanHao",default: "集柜单号"})}：</span>
                        <span>{orderInfo.containerCode||'-'}</span>
                    </Col>
                    <Col span={7}>
                        <span>{Lang({id: "RiQi",default: "日期"})}：</span>
                        <span>{orderInfo.actLoadDate?dayjs(orderInfo.actLoadDate).format("YYYY-MM-DD"):"-"}</span>
                    </Col>
                </Row>
                <div  className="padding-top-10 padding-bottom-10 border-bottom">
                    {orderInfo.destinationInfo}
                </div>
                {/* <div className="border-bottom">
                    <Row className="padding-top-10 padding-bottom-10">
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "MaiJia",default: "卖家"})}：</Col>
                                <Col span={20}>
                                    {orderInfo.newSellerCompanyName}
                                </Col>
                            </Row>
                        </Col>
                        <Col span={12} className={"black66"}>
                           {orderInfo.newSellerCompanyAddress}
                        </Col>
                    </Row>
                </div> */}
                <div className="border-bottom">
                    <Row className="padding-top-10 padding-bottom-10">
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "FaJianRenMaiJia",default: "发件人/卖家"})}：</Col>
                                <Col span={20}>{orderInfo.newSellerCompanyName||'-'}</Col>
                            </Row>
                        </Col>
                        <Col span={12}>
                            {/*<span>{Lang({id: "MaiFang",default: "买方"})}：</span>*/}
                            {/*<span>{orderInfo.receiverInfo||'-'}</span>*/}
                            <Row>
                                <Col span={4}>{Lang({id: "MaiFang",default: "买方"})}：</Col>
                                <Col span={20}>
                                    <p>{orderInfo.buyerCompanyName || '-'}</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="padding-top-10 padding-bottom-10">
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "FaJianRenMaiJia",default: "发件人/卖家"})}：</Col>
                                <Col span={20}>{orderInfo.newSellerCompanyAddress}</Col>
                            </Row>
                        </Col>
                        <Col span={12}>
                            <Row>
                            <Col span={4}></Col>
                            <Col span={20}>{Lang({id: "DiZhi",default: "地址"})}：{orderInfo.buyerCompanyAddress || '-'}</Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="padding-top-10 padding-bottom-10">
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "JiaoHuoTiaoKuan",default: "交货条款"})}：</Col>
                                <Col span={20}>{orderInfo.condition||'-'}</Col>
                            </Row>
                        </Col>
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "MuDiDiGuoJia",default: "目的地国家"})}：</Col>
                                <Col span={20}>{orderInfo.destinationCountry||'-'}</Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="padding-top-10 padding-bottom-10">
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "JiGui",default: "集柜"})}：</Col>
                                <Col span={20}>{orderInfo.cabinetNum||'-'}</Col>
                            </Row>
                            {/*<span>{Lang({id: "JiGui",default: "集柜"})}：</span>*/}
                            {/*<span>{orderInfo.cabinetNum||'-'}</span>*/}
                        </Col>
                        <Col span={12}>
                            <Row>
                                <Col span={4}>{Lang({id: "MuDiDiCheZhan",default: "目的地车站"})}：</Col>
                                <Col span={20}>{orderInfo.destinationReceiver||'-'}</Col>
                            </Row>
                            {/*<span>{Lang({id: "MuDiDiCheZhan",default: "目的地车站"})}：</span>*/}
                            {/*<span>{orderInfo.destinationReceiver||'-'}</span>*/}
                        </Col>
                    </Row>
                </div>
            </div>;
            break;
    }
    return info;
}
/**
 *
 * 栏目、统计信息
 * Author:  FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/19      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
export function getSampleColumns(orderType,orderInfo){
    let info = [];
    switch (orderType) {
        case 'load':
        case'load_sub':
            info =   [
                {
                    cnTitle: '标记',
                    cnTitleId: 'BiaoJi',
                    dataIndex: "isSign",
                    width: 60,
                    fixed:'left',
                    render: (text, record, index) => {
                        if(record.isSign){
                            return <img className="sign" src="https://oss.essaone.com/dd60f3b1-9b0a-4a72-8d50-3aef72359f20.svg" alt=""/>
                        }else{
                            return <img className="sign" src="https://oss.essaone.com/40915566-f815-4780-bf68-c7ef113ccf5a.svg" alt=""/>
                        }
                    }
                },
                {
                    cnTitle: '图片',
                    fixed:'left',
                    cnTitleId: 'TuPian',
                    dataIndex: "skuFileId",
                    render: (text, record, index) => {
                        return <img src={record.skuFileUrl} alt="" className="img"/>
                    }
                },
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    dataIndex: "buyerCode"
                },
                {
                    cnTitle: '分销商姓名',
                    cnTitleId: 'FenXiaoShangXingMing',
                    dataIndex: "distributorName"
                },
                {
                    cnTitle: 'po单号',
                    cnTitleId: 'PODingDan',
                    dataIndex: "poCode"
                },
                {
                    cnTitle: '产品条码',
                    cnTitleId: 'ChanPinTiaoMa',
                    dataIndex: "skuBarCode"
                },
                {
                    cnTitle: '商品编号',
                    cnTitleId: 'ShangPinBianHao',
                    dataIndex: "skuNo"
                },
                {
                    cnTitle: '工厂货号',
                    cnTitleId: 'GongChangHuoHao',
                    dataIndex: "skuFactoryNo"
                },
                {
                    cnTitle: '助记码',
                    cnTitleId: 'ZhuJiMa',
                    dataIndex: "factoryNoBuyer"
                },
                {
                    cnTitle: '中文品名',
                    cnTitleId: 'ZhongWenPinMing',
                    width: 250,
                    dataIndex: "nameCn"
                },
                {
                    cnTitle: '海关编码',
                    cnTitleId: 'HaiGuanBianMa',
                    dataIndex: "customsCode"
                },
                {
                    cnTitle: '俄文品名',
                    cnTitleId: 'ErWenPinMing',
                    dataIndex: "nameRu"
                },
                {
                    cnTitle: '英文品名',
                    width: 250,
                    cnTitleId: 'YinWenPinMing',
                    dataIndex: "nameEn"
                },
                {
                    cnTitle: '包装',
                    cnTitleId: 'BaoZhuang',
                    dataIndex: "skuPackageTypeName"
                },
                {
                    cnTitle: '箱数',
                    cnTitleId: 'XiangShu',
                    dataIndex: "deliveryQuantity"
                },
                {
                    cnTitle: '装量',
                    cnTitleId: 'ZhuangLiang',
                    dataIndex: "skuCapacity"
                },
                {
                    cnTitle: '内盒',
                    cnTitleId: 'ZhuangTai',
                    dataIndex: "skuInboxCount"
                },
                {
                    cnTitle: '总数量',
                    cnTitleId: 'ZongShuLiang',
                    dataIndex: "totalCount"
                },
                {
                    cnTitle: '内盒',
                    cnTitleId: 'NeiHe',
                    dataIndex: "skuInboxCount"
                },
                {
                    cnTitle: '毛/净重',
                    cnTitleId: 'ZhuangTai',
                    dataIndex: "skuGrossWeight",
                    render: (text, record, index) =>  <div>{record.skuGrossWeight}/{record.skuNetWeight}</div>
                },
                {
                    cnTitle: '总毛重',
                    cnTitleId: 'ZongMaoZhong',
                    dataIndex: "skuGrossWeightTotal"
                },
                {
                    cnTitle: '总净重',
                    cnTitleId: 'ZongJingZhong',
                    dataIndex: "skuNetWeightTotal"
                },
                {
                    title: __getServerLanguage("GuiGe")+'(CM)',
                    dataIndex: "skuOutBoxLength",
                    render: (text, record, index) => {
                        return <div>{record.skuOutBoxLength}*{record.skuOutBoxWidth}*{record.skuOutBoxHeight}</div>
                    }
                },
                {
                    title: Lang({id: "ZongTiJi", default: "总体积"}),
                    dataIndex: "skuOutBoxVolume",
                    render: (text, record, index) => {
                        return <div>{text}</div>
                    }
                },
                {
                    title: Lang({id: "DDPDanJia", default: "DDP单价"}),
                    dataIndex: "ddpPrice"
                },
                {
                    title: Lang({id: "DDPZongChengJiaoJia", default: "DDP总成交价"}),
                    dataIndex: "ddpPriceTotal"
                },
                {
                    title: Lang({id: "EXWDanJia", default: "EXW单价（CNY）"}),
                    dataIndex: "exwPrice"
                },
                {
                    title: Lang({id: "EXWZongChengJiaoJia", default: "EXW总成交价（CNY）"}),
                    dataIndex: "exwPriceTotal"
                },
                {
                    title: Lang({id: "FOBDanJia", default: "FOB单价（RUB）"}),
                    dataIndex: "fobPrice"
                },
                {
                    title: Lang({id: "FOBZongChengJiaoJia", default: "FOB总成交价（RUB）"}),
                    dataIndex: "fobPriceTotal"
                },
                {
                    title: Lang({id: "XiaDanLuBuHuiLv", default: "下单卢布汇率"}),
                    dataIndex: "exchangeRate"
                },
                {
                    title: Lang({id: "CIFJiaGe", default: "CIF价格(CNY)"}),
                    dataIndex: "cifPrice"
                },
                {
                    title: Lang({id: "TieZhiBianHao", default: "贴纸编号"}),
                    dataIndex: "stickerCode"
                },
            ];
            break;
        case 'trucking':
        case 'trucking_sub': // 样品随车单
            info = [
                {
                    title: Lang({id: "BianHao", default: "编号"}),
                    width:'60px',
                    dataIndex:'no',
                    render: (text, record, index) =><div>{index+1}</div>
                },
                {
                    title: Lang({id: "HaiGuanBianMa", default: "海关编码"}),
                    width: 120,
                    dataIndex: "customsCode"
                },
                {
                    title: Lang({id: "ShangPinBianHao", default: "商品编号"}),
                    width: 120,
                    dataIndex: "skuNo"
                },
                {
                    cnTitle: '俄文品名',
                    cnTitleId: 'ErWenPinMing',
                    width: 250,
                    dataIndex: "nameRu"
                },
                {
                    title: Lang({id: "ShengChanGuo", default: "生产国"}),
                    dataIndex: "countries"
                },
                {
                    title: Lang({id: "YinWenPinMing", default: "英文品名"}),
                    width: 250,
                    dataIndex: "nameEn"
                },
                {
                    title: Lang({id: "ZongGeShuZhuangLiang", default: "总个数（装量）"}),
                    width: 150,
                    dataIndex: "skuCount"
                },
                {
                    title: Lang({id: "JianShu", default: "件数"}),
                    width: 120,
                    dataIndex: "deliveryQuantity"
                },
                {
                    title: Lang({id: "JingZhong", default: "净重"}),
                    width: 120,
                    dataIndex: "skuNetWeight"
                },
                {
                    title: Lang({id: "MaoZhong", default: "毛重"}),
                    width: 120,
                    dataIndex: "skuGrossWeight"
                },
                {
                    title: Lang({id: "DanJia", default: "单价"}),
                    width: 120,
                    dataIndex: "price"
                },
                {
                    title: Lang({id: "ZhongJia", default: "总价"}),
                    width: 120,
                    dataIndex: "totalPrice"
                },
            ];
            break;
    }
    return info;
}

export function getTotal(pageData) {
    let totalSkuCount = 0, totalDeliveryQuantity = 0, totalSkuNetWeight=0, totalSkuGrossWeight=0, totalSkuPrice=0;
    pageData.forEach(({ skuCount, deliveryQuantity,skuNetWeight,skuGrossWeight,totalPrice }) => {
        if(Number(skuCount))totalSkuCount += Number(skuCount);
        if(Number(deliveryQuantity))totalDeliveryQuantity += Number(deliveryQuantity);
        if(Number(skuNetWeight))totalSkuNetWeight += Number(skuNetWeight);
        if(Number(skuGrossWeight))totalSkuGrossWeight += Number(skuGrossWeight);
        if(Number(totalPrice))totalSkuPrice += Number(totalPrice);
    });
    if(totalSkuNetWeight>0){
        totalSkuNetWeight= toFixed2(totalSkuNetWeight,2);
    }
    if(totalSkuGrossWeight>0){
        totalSkuGrossWeight= toFixed2(totalSkuGrossWeight,2);
    }
    if(totalSkuPrice>0){
        totalSkuPrice= toFixed2(totalSkuPrice,2);
    }
    return (<SumRow>
        <SumCell index={0}>{Lang({id: "HeJi", default: "合计"})}</SumCell>
        <SumCell index={1} colSpan={5}>

        </SumCell>
        <SumCell index={2}>
            {totalSkuCount}
        </SumCell>
        <SumCell index={3}>
            {totalDeliveryQuantity}
        </SumCell>
        <SumCell index={4}>
            {totalSkuNetWeight}
        </SumCell>
        <SumCell index={5}>
            {totalSkuGrossWeight}
        </SumCell>
        <SumCell index={6}>
        </SumCell>
        <SumCell index={7}>
            {totalSkuPrice}
        </SumCell>
    </SumRow> );
}